import axios from 'axios';
//samsung
export const errCheck = (err) => {
    if(err.response.data.statusCode=='401'){
        localStorage.removeItem("token");
        window.location.href = '/login';
    }
};
export default class UserService {
    async getUserList(nname, uname, hchild, agechild, gend, agGrp, marrStat,status,hpet, minPoint, maxPoint, sdate, edate) {
        return await axios
            .post(`/user/all`, {
                nickname: nname,
                username: uname,
                has_children: hchild,
                children_age: agechild,
                gender: gend,
                age_group: agGrp,
                marital_status: marrStat,
                status: status,
                has_pet: hpet,
                min_point: minPoint,
                max_point: maxPoint,
                start_date: sdate,
                end_date: edate,
            })
            .then((res) => res.data.data)
            .catch((err) => {
                errCheck(err);
            });
    }
    async getUserListsingle(startdate) {
        return await axios.post(`/user`, { status: 'active', startDate: startdate }).then((res) => res.data.data.users).catch((err) => {
            errCheck(err);
        });
    }

    async addUser(name, mobile, email, gender, pass, confirm_pass) {
        return await axios.post(`/user/add`, { name: name, mobile: mobile, email: email, gender: gender, password: pass, confirm_password: confirm_pass }).then((res) => res.data.data[0]);
    }
    async updateUser(ids, nick, nm, gend, ag_grp, marr_stat, stat, child, childList, pets, petType) {
        return await axios.patch(`/user/update`, { id: ids, nickname: nick, name: nm, gender: gend, age_group: ag_grp, married: marr_stat, status: stat, has_children: child, children: childList, has_pets: pets, pets: petType }).then((res) => res);
    }

    async deleteUser(id) {
        return await axios.delete(`/user/delete`, { deleteIdArray: id }).then((res) => res) .catch((err) => {
            errCheck(err);
        });
    }
    async viewUser(ids) {
        return await axios.get(`/user/${ids}`).then((res) => res.data);
    }
    async getExcel(nname,uname, hchild, agechild, gend, agGrp, marrStat,status,hpet, minPoint, maxPoint, sdate, edate,dreason) {
        return await axios({
            url: `/user/download`,
            method: 'POST',
            responseType: 'blob', // important
            data: {
                nickname: nname,
                username: uname,
                has_children: hchild,
                children_age: agechild,
                gender: gend,
                age_group: agGrp,
                marital_status: marrStat,
                status: status,
                has_pet: hpet,
                min_point: minPoint,
                max_point: maxPoint,
                start_date: sdate,
                end_date: edate,
                reason:dreason,
            },
        }).then((res) => res)
        .catch((err) => {
            errCheck(err);
        });
    }
    async getPointHistoryExcel(uid) {
        return await axios({
            url: `/user/points_history/download`,
            method: 'POST',
            responseType: 'blob', // important
            data: {
                user_id:uid
            },
        }).then((res) => res)
        .catch((err) => {
            errCheck(err);
        });
    }
    
}
